import { useQueryClient, useMutation } from '@tanstack/react-query'

import { updateBooking, type UpdateBookingOptions } from '@flecto/api/saas'
import { type CoreBookingPayload, type ParameterID } from '@flecto/types'

type MutationPayload = {
  bookingId?: ParameterID
  booking: CoreBookingPayload
  options?: UpdateBookingOptions
}

export function useMutationUpdateBooking() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationKey: ['MutationUpdateBooking'],
    mutationFn: async ({ bookingId, booking, options }: MutationPayload) => {
      return await updateBooking(bookingId ?? '', booking, options)
    },
    onSuccess: (booking) => {
      const bookingId = Number(booking.internal_id)

      queryClient.invalidateQueries({
        queryKey: ['QueryGetBookingById', bookingId],
        refetchType: 'all',
      })

      queryClient.invalidateQueries({
        queryKey: ['QueryGetBFFBookingById', Number(bookingId)],
        refetchType: 'all',
      })

      queryClient.invalidateQueries([
        'QueryGetBookingInsuranceStatus',
        bookingId,
      ])

      queryClient.invalidateQueries([
        'QueryGetAllBookingServices',
        Number(bookingId),
      ])

      queryClient.resetQueries([
        'QueryGetAllBookingProductsAvailability',
        bookingId,
      ])

      queryClient.resetQueries([
        'QueryGetAllBookingProductsUnavailable',
        bookingId,
      ])

      queryClient.resetQueries(['QueryGetAllBookingProducts', bookingId])

      queryClient.resetQueries([
        'QueryGetAllBookingProductsSelection',
        bookingId,
      ])

    },
  })
}
